import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";

export default function ChiriasStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <InputField
        label="Nume complet"
        value={data.chiriasNume}
        onChange={update("chiriasNume")}
        placeholder="ex: Ionescu Maria"
        required
        error={errors.chiriasNume}
      />
      <InputField
        label="Adresa de domiciliu"
        value={data.chiriasAdresa}
        onChange={update("chiriasAdresa")}
        placeholder="ex: Str. Libertății nr. 10, Cluj-Napoca"
        required
        error={errors.chiriasAdresa}
      />
      <OptionalFields>
        <InputField
          label="CNP"
          value={data.chiriasCNP}
          onChange={update("chiriasCNP")}
          placeholder="ex: 2987654321098"
          half
          error={errors.chiriasCNP}
          helperText="Opțional — poți completa de mână pe document"
        />
        <InputField
          label="Serie și nr. CI"
          value={data.chiriasCI}
          onChange={update("chiriasCI")}
          placeholder="ex: MZ 654321"
          half
          error={errors.chiriasCI}
          helperText="Opțional — poți completa de mână pe document"
        />
      </OptionalFields>
    </div>
  );
}
